import React from 'react';
import { Button } from 'react-bootstrap'; // Import React Bootstrap Button
import { useAuth } from './AuthContext'; // Import the AuthContext to use the logout function

const LogoutButton = () => {
  const { logout } = useAuth(); // Access the logout function from AuthContext

  return (
    <Button
      variant="danger" // Bootstrap's danger variant for a red button
      // size="lg" // Large button size
      onClick={logout} // Trigger logout when button is clicked
      // className="absolute r-5 b-5"
    >
      Wyloguj
    </Button>
  );
};

export default LogoutButton;
